import Table from "../../../../../common/components/table";


export const TemplatePlansComponent = ({
    handleDelete, additionButtons, handleEdit, columnDefs, selectedTemplateValues,
}: any) => {

    return (
        <div className="w-full">
            <Table columnData={columnDefs} rowData={selectedTemplateValues}
                onEdit={handleEdit} headingName="Template Group Details"
                additionButtons={additionButtons} onDelete={handleDelete} />
        </div>
    )
}
export default TemplatePlansComponent;
